// extracted by mini-css-extract-plugin
export default {"signupBlockFooter":"signupBlockFooter-z5DUF","btnSignupFooter":"btnSignupFooter-TT75l","signupBlockFooterMobile":"signupBlockFooterMobile-sCyNk"};